var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-center margin-top-16",staticStyle:{"gap":"20px"}},[_c('btn-signin-kakao'),_c('btn-signin-naver'),_c('btn-signin-facebook')],1)}
var staticRenderFns = []

export { render, staticRenderFns }